
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-chat-ui-for-content-creation",
      function () {
        return require("private-next-pages/ai-chat-ui-for-content-creation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-chat-ui-for-content-creation"])
      });
    }
  